<template>
  <v-row class="fill-height">
    <v-col class="d-flex flex-column">
      <div
        class="cursor-pointer"
        :class="{ 'flex-1': $vuetify.breakpoint.mdAndUp }"
        @click="onClickHeader"
      >
        <span class="text-uppercase tcdc-menu-title bold">{{ title }}</span>
      </div>
      <v-expansion-panels flat accordion class="flex-1">
        <template v-for="(item, i) in items">
          <v-expansion-panel :key="i" class="menu-expandable">
            <v-expansion-panel-header class="px-0 tcdc-panel-header" @click="() => onClick(item)">
              <span
                class="white--text text-capitalize tcdc-menu-content menu-highlight bold"
              >{{ item[`name_${lang}`] }}</span>
              <template v-slot:actions>
                <v-icon class="white--text" size="medium" v-if="item.subMenuList && item.subMenuList.length > 0">mdi-plus</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content
              :class="{
                'my-3': item.subMenuList && item.subMenuList.length > 0,
              }"
            >
              <template v-for="(item, index) of item.subMenuList">
                <div
                  :key="index"
                  class="text-capitalize tcdc-menu-content bold"
                  @click="() => onClickSubmenu(item)"
                >{{ item[`name_${lang}`] }}</div>
              </template>
            </v-expansion-panel-content>
            <MenuDivider />
          </v-expansion-panel>
        </template>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
import MenuDivider from "../dividers/MenuDivider";
import { mapState } from 'vuex';
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array
    }
  },
  components: {
    MenuDivider
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang
    })
  },
  methods: {
    onClick(item) {
      this.$emit("onClick", item);
    },
    onClickSubmenu(item) {
      this.$emit("onClickSubMenu", item);
    },
    onClickHeader() {
      this.$emit("onClickHeader");
    }
  }
};
</script>

<style lang="scss">
.menu-expandable {
  background-color: black !important;
}
</style>
